import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loader from '../components/theme/Loader'
import AdminTabs from "../components/admin/AdminTabs"



function AdminPage() {

    const [loadReady, setLoadReady] = useState(false)
    const userDetails = useSelector(state => state.userDetails.user)
    const userLogin = useSelector(state => state.userLogin)
   

    useEffect(() => {
        if (userDetails && Object.keys(userDetails).length > 0) {
            setLoadReady(true)
        }

    }, [userDetails])



    return (
        <>
      


            {loadReady === true && userDetails && userDetails.role && userDetails.role !== "admin" ?
                <Navigate to="/" replace={true} /> :
                loadReady === true && userDetails && userDetails.role && userDetails.role === "admin" ?
                    <>


                        <AdminTabs />

                    </>
                    :
                    <Loader />

            }

        </>
    )
}

export default AdminPage